import { createUseStyles } from 'react-jss'
import { componentsGap } from '../content/constants'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: `${componentsGap}px`
  }
})

export default useStyles
